module.exports = __webpack_public_path__ + "img/inactive-24.5e490053.svg";